import { styled } from '@abyss/web/tools/styled';
import { Modal } from '@abyss/web/ui/Modal';

export const GeospatialModalContainer = styled(Modal, {
  '.abyss-modal-header-container': {
    paddingTop: '0',
    paddingBottom: '0',
  },
});

export const GeospatialModalSection = styled(Modal.Section, {
  '.abyss-modal-section-root': {
    paddingTop: '0',
  },
});

export const GeospatialButtonContainer = styled('div', {
  marginTop: '16px',
});
